/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppQueueRouteImport } from './routes/_app/queue'
import { Route as AppProvidersRouteImport } from './routes/_app/providers'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCasesIndexRouteImport } from './routes/_app/cases/index'
import { Route as AppMissionsMissionIdRouteImport } from './routes/_app/missions/$missionId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppQueueRoute = AppQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProvidersRoute = AppProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCasesIndexRoute = AppCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMissionsMissionIdRoute = AppMissionsMissionIdRouteImport.update({
  id: '/missions/$missionId',
  path: '/missions/$missionId',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/providers': typeof AppProvidersRoute
  '/queue': typeof AppQueueRoute
  '/reports': typeof AppReportsRoute
  '/rules': typeof AppRulesRoute
  '/users': typeof AppUsersRoute
  '/missions/$missionId': typeof AppMissionsMissionIdRoute
  '/cases/': typeof AppCasesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/providers': typeof AppProvidersRoute
  '/queue': typeof AppQueueRoute
  '/reports': typeof AppReportsRoute
  '/rules': typeof AppRulesRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/missions/$missionId': typeof AppMissionsMissionIdRoute
  '/cases': typeof AppCasesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/providers': typeof AppProvidersRoute
  '/_app/queue': typeof AppQueueRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/rules': typeof AppRulesRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/missions/$missionId': typeof AppMissionsMissionIdRoute
  '/_app/cases/': typeof AppCasesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/providers'
    | '/queue'
    | '/reports'
    | '/rules'
    | '/users'
    | '/missions/$missionId'
    | '/cases/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/dashboard'
    | '/providers'
    | '/queue'
    | '/reports'
    | '/rules'
    | '/users'
    | '/'
    | '/missions/$missionId'
    | '/cases'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/dashboard'
    | '/_app/providers'
    | '/_app/queue'
    | '/_app/reports'
    | '/_app/rules'
    | '/_app/users'
    | '/_app/'
    | '/_app/missions/$missionId'
    | '/_app/cases/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rules': {
      id: '/_app/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/queue': {
      id: '/_app/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AppQueueRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/providers': {
      id: '/_app/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof AppProvidersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof AppCasesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/missions/$missionId': {
      id: '/_app/missions/$missionId'
      path: '/missions/$missionId'
      fullPath: '/missions/$missionId'
      preLoaderRoute: typeof AppMissionsMissionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppProvidersRoute: typeof AppProvidersRoute
  AppQueueRoute: typeof AppQueueRoute
  AppReportsRoute: typeof AppReportsRoute
  AppRulesRoute: typeof AppRulesRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMissionsMissionIdRoute: typeof AppMissionsMissionIdRoute
  AppCasesIndexRoute: typeof AppCasesIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppProvidersRoute: AppProvidersRoute,
  AppQueueRoute: AppQueueRoute,
  AppReportsRoute: AppReportsRoute,
  AppRulesRoute: AppRulesRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppMissionsMissionIdRoute: AppMissionsMissionIdRoute,
  AppCasesIndexRoute: AppCasesIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
